import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

import FullObjectPane from "./EditObject/FullObjectPane";
import { QuizObject } from "../../../../store/modquiz/quiz_objects/quiz-object";
import SidebarObject from "../../Component/SidebarObject";
import { modquizPaths } from "../../index";
import useStores from "../../../../utils/useStores";

import "./style.css";

const QuizObjectRoute = observer(() => {
    const { subject_user, subject_slug, object_id } = useParams<{
        subject_user: string;
        subject_slug: string;
        object_id?: string;
    }>();
    const navigate = useNavigate();
    const rootStore = useStores();

    const [newTitle, setNewTitle] = useState("");
    const [creating, setCreating] = useState(false);

    const isNew = !object_id;
    const subjectHashKey = `${subject_user}/${subject_slug}`;

    useEffect(() => {
        rootStore.subjectStore.fetchOne(subject_user!, subject_slug!);
        if (!isNew) {
            rootStore.objectStore.fetchByID(object_id!);
        }
    }, [object_id, subject_user, subject_slug]);

    const subject = rootStore.subjectStore.subjects.get(subjectHashKey);
    const quiz_object: QuizObject | undefined = object_id
        ? rootStore.objectStore.quiz_objects.get(object_id)
        : undefined;

    const handleNewTitleSave = () => {
        const title = newTitle.trim();
        if (!title || creating) return;
        setCreating(true);
        rootStore.objectStore.create(
            subject_user!,
            subject_slug!,
            title,
            (err: boolean, res: any) => {
                if (!err) {
                    navigate(
                        modquizPaths.quizObjectNew(subjectHashKey, String(res._id)),
                        { replace: true }
                    );
                } else {
                    setCreating(false);
                }
            }
        );
    };

    const handleFieldChange = (field: string, value: string) =>
        rootStore.objectStore.setQuizObject(field, object_id!, value);

    if (!subject) return <div />;

    const sidebar = (
        <Grid item xs={"auto"} sm={3} md={2}>
            <SidebarObject
                subjectHashKey={subjectHashKey}
                subject={subject}
                hasCreateAccess={!!rootStore.profileStore.isLoggedIn}
                subject_user={subject_user!}
                subject_slug={subject_slug!}
            />
        </Grid>
    );

    if (isNew) {
        return (
            <Grid container direction="row">
                {sidebar}
                <Grid item xs={12} sm={9} md={10}>
                    <div className="quiz-object-edit-container">
                        <div className="Profile">
                            <TextField
                                autoFocus
                                label="Card title"
                                value={newTitle}
                                onChange={e => setNewTitle(e.target.value)}
                                onBlur={handleNewTitleSave}
                                onKeyDown={e => e.key === "Enter" && handleNewTitleSave()}
                                disabled={creating}
                                fullWidth
                                variant="outlined"
                                style={{ marginTop: "2rem" }}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container direction="row">
            {sidebar}
            <Grid item xs={12} sm={9} md={10}>
                <div className="quiz-object-edit-container">
                    <div className="Profile">
                        {quiz_object && (
                            <FullObjectPane
                                handleTitleChange={(e: any) =>
                                    handleFieldChange("title", e?.currentTarget?.value ?? "")
                                }
                                onSave={() => rootStore.objectStore.save(quiz_object, () => {})}
                                quiz_object={quiz_object}
                            />
                        )}
                    </div>
                </div>
            </Grid>
        </Grid>
    );
});

export default QuizObjectRoute;
